// TalentsRouter.js
import { Routes, Route, useOutletContext } from "react-router-dom";
import { Dashboard } from "../Pages/Private/Talent/Dashboard";
import { Collaborateurs } from "../Pages/Private/Talent/Collaborateurs";
import { CollaborateurDetail } from "../Pages/Private/Talent/CollaborateurDetail";
import { Recrutement } from "../Pages/Private/Talent/Recrutement";
import { CandidateDetail } from "../Pages/Private/Talent/CandidateDetail";
import { Entretiens } from "../Pages/Private/Talent/Entretien";
import { EntretienDetail } from "../Pages/Private/Talent/EntretienDetail";
import { Formations } from "../Pages/Private/Talent/Formations";
import { Objectifs } from "../Pages/Private/Talent/Objectifs";

export const TalentsRouter = () => {
    useOutletContext();
    return (
        <Routes>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="collaborateurs" element={<Collaborateurs />} />
            <Route path="collaborateurs/:id" element={<CollaborateurDetail />} />
            <Route path="recrutement" element={<Recrutement />} />
            <Route path="recrutement/:id" element={<CandidateDetail />} />
            <Route path="entretiens" element={<Entretiens />} />
            <Route path="entretiens/:id" element={<EntretienDetail />} />
            <Route path="objectifs" element={<Objectifs />} />
            <Route path="formations" element={<Formations />} />
        </Routes>
    );
};

export default TalentsRouter;
